import React from "react";
import { Draggable } from "react-beautiful-dnd";
import BlockImage from "../assets/block.png";
import Block from "../models/block";
import "./DraggableBlock.css";

/** Slightly shrink type for longer labels so wide glyphs (KGRedHands) stay inside the block art. */
function blockLabelFontScale(label: string): number {
  const n = label.length;
  if (n <= 4) return 1;
  if (n === 5) return 0.88;
  if (n === 6) return 0.78;
  if (n === 7) return 0.7;
  if (n === 8) return 0.62;
  return Math.max(0.5, 0.62 - (n - 8) * 0.045);
}

type Props = {
  block: Block;
  index: number;
  onClick?: (block: Block) => void;
};

const DraggableBlock = (props: Props) => {
  const { block, index, onClick } = props;

  const handleBlockClick = (block: Block) => {
    if (onClick) {
      onClick(block)
    }
  }

  const isHexColorName = block.name.startsWith("#");

  return (
    <Draggable draggableId={block.id} index={index}>
      {(provided) => (
        <div
          ref={provided.innerRef}
          className="Block"
          {...provided.draggableProps}
          {...provided.dragHandleProps}
          onClick={() => handleBlockClick(block)}
        >
          <img
            src={BlockImage}
            className="BlockImage"
            alt={block.name}
          />
          <div
            style={{
              color: block.textColor,
              ...(!isHexColorName
                ? ({
                    "--block-fs-scale": String(blockLabelFontScale(block.name)),
                  } as React.CSSProperties)
                : {}),
            }}
            className="BlockContent"
          >
            {isHexColorName ? (
              <div
                className="BlockCircle"
                style={{
                  backgroundColor: block.name,
                }}
              />
            ) : (
              block.name
            )}
          </div>
        </div>
      )}
    </Draggable>
  );
};

export default DraggableBlock;
